export default {
  'it-IT': {
    lowerPriceThanXDays: 'Prezzo più basso degli ultimi {days} giorni:',
  },
  'fr-FR': {
    lowerPriceThanXDays: 'Le prix le plus bas des {days} derniers jours :',
  },
  'es-ES': {
    lowerPriceThanXDays: 'Precio más bajo en los últimos {days} días:',
  },
  'en-GB': {
    lowerPriceThanXDays: 'Lowest price in the last {days} days:',
  },
  'en-US': {
    lowerPriceThanXDays: 'Lowest price in the last {days} days:',
  },
  'de-DE': {
    lowerPriceThanXDays: 'Der niedrigste Preis in den letzten {days} Tagen:',
  },
  'en-AU': {
    lowerPriceThanXDays: 'Lowest price in the last {days} days:',
  },
  'ko-KR': {
    lowerPriceThanXDays: 'Lowest price in the last {days} days:',
  },
};
